/** Filtro "Sem WhatsApp no Google" da lista de Monitoramento (whatsapp=sem-no-google no backend). */

export const SEM_WHATSAPP_NO_GOOGLE = "sem-no-google";

export const FILTRO_WHATSAPP = {
  id: "whatsapp",
  label: "WhatsApp no Google",
  options: [
    { label: "Todos", value: "" },
    { label: "Sem WhatsApp no Google", value: SEM_WHATSAPP_NO_GOOGLE },
  ],
};

export const CHIP_SEM_WHATSAPP = "Sem WhatsApp no Google";

export const paramWhatsapp = (valor: string | undefined): string | undefined =>
  valor ? valor : undefined;
